import React from 'react'
import './about.css'
import ME from '../../assets/mers.jpeg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'  
import {VscFolderLibrary} from 'react-icons/vsc' 
import {TbMicrophone2} from 'react-icons/tb'
const about = () => {
  return (
    <section id='about'>
      <h5>Set To Know</h5>
      <h2>About Me</h2>
    <div className='container about_container'>
      <div className='about_me'> 
      <div className='about_me-image'>
        <img src={ME} alt="" />
      </div>
      </div>

      <div className='about_content'>
      <div className='about_cards'>

        <article className='about_card'>
        <FaAward className='about_icon'/>
        <h5> Experience </h5>
        <small>1 year Working</small>
        </article>

        <article className='about_card'>
        <FiUsers className='about_icon'/>
        <h5> Clients </h5>
        <small>Not yet any</small>
        </article>
      
      
        <article className='about_card'>
        <VscFolderLibrary className='about_icon'/>
        <h5> Projects </h5>
        <small>50+ Completed</small>
        </article>

        <article className='about_card'>
        <TbMicrophone2 className='about_icon'/>
        <h5> Speaker </h5>
        <small>10+ Sessions</small>
        </article>

       

      
      </div>
        <p className='para'>
        I am a dedicated and motivated software engineering student with a strong passion for continuously learning and embracing new technologies. With 1 year of experience as a frontend developer, I have honed my problem-solving skills both in project management and programming. As a confident and articulate speaker, I have had the privilege of delivering numerous sessions to students at universities, colleges, and schools. My ultimate goal is to become a proficient full stack developer and establish my own software house, leading a team that empowers and guides aspiring individuals in achieving their goals and paving the way for a successful future.
        </p>

        <a href="#contact" className='btn btn-primary'> Let's Talk</a>
      
      </div>
    </div>

      
    </section>
  )
}

export default about